<br><br>
<div class="login-box center">
    <div class="login-logo">
        <img class="logoimg" src="assets/img/logo.webp">
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">Get Change Password Link</p>
  
        <form action="javascript:void(0);">
          <div class="input-group mb-3">
            <input type="email" name="username" class="form-control" placeholder="Email" [(ngModel)]="user.email">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
          </div>
          <!-- <div class="input-group mb-3">
            <input type="tel" name="Contact No." class="form-control" placeholder="Contact No." [(ngModel)]="user.tel">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="far fa-address-book"></span>
              </div>
            </div>
          </div> -->
          <div class="row">
          
            <!-- /.col   (click)="log()"-->
            <div class="col-12">
              <button type="submit" class="btn btn-primary btn-block" (click)="getPassword()">Get Link</button>
            </div>
            <!-- /.col -->
          </div>
        </form>
        <!-- /.social-auth-links -->
        <p class="mb-1">
          <a>check your email</a>
        </p>
      </div>
      <!-- /.login-card-body -->

